// PayOrderBakEdit.tsx
import PayOrderEditBase from './PayOrderEditBase';

const PayOrderBakEdit = (props: any) => (
    <PayOrderEditBase apiId="payOrderBak" outerProps={props} />
);

export default PayOrderBakEdit;